import { gql } from '@apollo/client';

export const QUERY_TMS_TRANSPORT_DASHBOARD = gql`
    query QueryTmsTransportDashboard($input: TmsTransportDashboardInput!) {
        queryTmsTransportDashboard(input: $input) {
            calculatedAt
            items {
                timePeriod
                startSortingId
                startSortingName
                routeId
                routeName
                segmentName
                tripCount
                departPackageQty
                avgPackageQty
                rawDepartPackageQty
                rawAvgPackageQty
                rawDepartLoadNumerator
                rawAvgLoadNumerator
                rawPackageLoadMaxLimit
                rawActualLoadWeight
                rawTheoryLoadWeight
                rawOnTimeArrivalTripCount
                rawOnTimeDepartTripCount
                rawOverDriveDurationCount
                prevTripCount
                prevRawDepartPackageQty
                prevRawAvgPackageQty
                prevRawDepartLoadNumerator
                prevRawAvgLoadNumerator
                prevRawPackageLoadMaxLimit
                prevRawActualLoadWeight
                prevRawTheoryLoadWeight
                prevRawOnTimeArrivalTripCount
                prevRawOnTimeDepartTripCount
                prevRawOverDriveDurationCount
                departLoadRate
                avgLoadRate
                departWeightLoadRate
                onTimeArrivalRate
                onTimeDepartRate
                avgOverDriveDuration
                tripCountWow
                rawDepartPackageQtyWow
                departPackageQtyWow
                avgPackageQtyWow
                departLoadRateWow
                avgLoadRateWow
                departWeightLoadRateWow
                onTimeArrivalRateWow
                onTimeDepartRateWow
                avgOverDriveDurationWow
            }
        }
    }
`;
